import React from 'react';
import AboutCard from '../AboutCard/AboutCard';
const AboutInfo = ({aboutInfo}) => {
    return (
        <div className="d-flex justify-content-start">
            <div className="row gy-2">
                {aboutInfo?.map(aboutInfo=> <AboutCard info={aboutInfo} key={Date.now() + Math.random()}></AboutCard>)}
            </div>
        </div>
    );
};

export default AboutInfo;